import React from 'react';

function Footer() {
    return (
        <footer>
            <hr/>
            <small id = "ft1"> <strong >What ?</strong>You are also interested in music? Check this website developed by us: <a href="http://lulabazooka.herokuapp.com/ ">Lulabazooka</a></small>
            <br/>
            <small id = "ft2">© Copyright 2020 Damianos and Fábio</small>
        </footer>
    )
}

export default Footer;
